import { render, staticRenderFns } from "./GridTermosContratos.vue?vue&type=template&id=35edec3d&scoped=true&"
import script from "./GridTermosContratos.vue?vue&type=script&lang=js&"
export * from "./GridTermosContratos.vue?vue&type=script&lang=js&"
import style0 from "./GridTermosContratos.vue?vue&type=style&index=0&id=35edec3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35edec3d",
  null
  
)

export default component.exports